<div [formGroup]="tenantFormGroup" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    placeholder="Nexato GmbH"
    label="Name">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="additionalName"
    placeholder="Saas-Plattform Provider"
    label="Zusätzlicher Name">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="email"
    placeholder="mail@nexato.de"
    label="Email">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="phone"
    placeholder="+49 661 480 191 00"
    label="Telefon">
  </nx-edit-text-input>
  <nx-textfield-input
    formControlName="description"
    placeholder="Interner (nexato) Vermerk zum Tenant..."
    label="Beschreibung">
  </nx-textfield-input>
  <nx-edit-text-input
    formControlName="addressLine0"
    placeholder="Florengasse 18"
    label="Addresszeile 1">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="addressLine1"
    label="Addresszeile 2">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="postalCode"
    placeholder="36043"
    label="Postleitzahl">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="city"
    placeholder="Fulda"
    label="Ort">
  </nx-edit-text-input>
  <nx-edit-selectCountry-input
    formControlName="country">
  </nx-edit-selectCountry-input>
  <nx-edit-select-input
    formControlName="vatType"
    placeholder="Steuer-ID Typ"
    label="Steuer-ID Typ"
    [options]="vatTypeOptions">
  </nx-edit-select-input>
  <nx-edit-text-input
    formControlName="vatNumber"
    placeholder="DE123456789"
    label="Umsatzsteuer-Identifikationsnummer">
  </nx-edit-text-input>
  <div *ngIf="tenantFormGroup.get('vatNumber')?.errors?.invalidVatNumber">
    Invalid VAT Number format.
  </div>
  <nx-checkbox-text-input
    formControlName="paymentProviderEnabled"
    label="Zahlungsanbieterintegration">
  </nx-checkbox-text-input>
  <nx-edit-text-input
    *ngIf="tenant"
    formControlName="paymentProviderId"
    placeholder="cus_Qp4ltR8IV5vx7e"
    label="Zahlungsanbieter-Id">
  </nx-edit-text-input>

</div>
<div>
